import { DeviceTypeOption } from 'src/app/pages/device-register/models/device-type-option.interface';
import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';

export const deviceTypeOptionActions = createEagerSelectActions<DeviceTypeOption>('[Device Type Options]');
